module.exports = __webpack_public_path__ + "static/media/wallet.8ef638cf.png";